<template>
  <div>
    <v-btn 
      class="mx-2" icon small 
      :color="color"
      @click="toggleFavorite"
    >
      <v-icon dark>mdi-pin</v-icon>
    </v-btn>
    
  </div>
</template>

<script>

// console.log("[window] ", window);
// const {serviciosService} = api.services;
// const {productosService} = api.services;

export default {
  model: {
    prop: 'favorite'
  },
  props: {
    favorite: {
      type: [Number, Boolean, String],
      required: true
    },
    id: {
      type: [Number],
      required: true
    },
    itemType: {
      type: [String],
      required: true
    }
    // color: "gray"
  },
  data: function(){
    return {
      favorited: this.favorite,
      serviceID: this.id
    };
  },
  computed: {
    isFavorited: {
      get: function () {
        return this.favorited;
      },
      set: function(value){
        this.favorited = value;
      },
    },
    type: {
      get: function(){
        console.log("[Getting the itemType]: ");
        return this.itemType;
      }, 
      set: function(payload) {
        console.log("[Setting the itemType]: ", payload);
        this.itemType = payload;
      }
    },
    color: {
      get: function(){
        return this.isFavorited ? 'blue' : 'gray';
      }
    }
  },
  methods: {
    toggleFavorite: function(){
      this.isFavorited = this.isFavorited === 1 ? 0 : 1;
      // if(this.type === "service")
      //   serviciosService.updateFavorite(this.serviceID, this.isFavorited);
      // else if(this.type === "product")
      //   productosService.updateFavorite(this.serviceID, this.isFavorited);
      this.$emit('toggledFavorite', this.isFavorited);
    }
  }
};
</script>